export default "__VITE_ASSET__ChmeJEzX__"